module.exports = __webpack_public_path__ + "img/boundary-event.5bf51421.svg";